import styles from '../../styles/modules/newsAlert/Detail.module.scss';

const EXPERTISE_BANNER_MAPPER = [
    {
        expertise: ['mortgages'],
        banner: {
            href: 'https://www.finanzecapital.com/?utm_source=newspage',
            src: 'finanze-banner.png',
            id: 'banner_finanze',
        },
    },
    {
        expertise: [
            'pensions',
            'investments',
            'wealth manager',
            'wealth management',
            'financial planner',
            'financial advice',
            'IFA',
            'investing',
            'equity investments',
            'retirement planning',
            'stock markets',
            'money coach',
            'chartered financial planner',
            'independent financial adviser',
        ],
        banner: {
            href: 'https://investingreviews.co.uk/?utm_source=newspage',
            src: 'investing-reviews.png',
            id: 'banner_investingreviews',
        },
    },
    {
        expertise: [
            'law',
            'HR',
            'management',
            'technology',
            'insurance',
            'property',
            'accountancy/tax',
            'entrepreneurship',
        ],
        banner: {
            href: 'https://www.net-worthntwrk.com?utm_source=newspage&utm_medium=banner&utm_campaign=ntwrk-sponsorship',
            src: 'net-worth-ntwrk.png',
            id: 'net_worth_ntwrk',
        },
    },
];

const Banner = ({ campaign = [] }) => {
    if (!campaign || !campaign.isActive) return null;
    const { id, bannerLink, bannerSrc, sponsorName } = campaign;

    return (
        <div className={['mb-s', styles.logo].join(' ')}>
            <a href={bannerLink} target={'_blank'} rel="sponsored noopener">
                <img
                    id={`banner-${id}`}
                    className={[styles.banner].join(' ')}
                    src={`/img/banners/${bannerSrc}`}
                    alt={
                        sponsorName
                            ? `Advertisement: ${sponsorName}`
                            : 'Advertisement'
                    }
                />
            </a>
        </div>
    );
};

export default Banner;
